// Utensils screen (`/utensils`) — thin wrapper over PrereqList.
import PrereqList from './PrereqList';

export default function Utensils() {
  return <PrereqList kind="utensils" heading="Utensils" />;
}
